import { extensions } from '../../extensions/Extensions.mjs';
import { CanvasTextPipe } from './canvas/CanvasTextPipe.mjs';
import { CanvasTextSystem } from './canvas/CanvasTextSystem.mjs';

"use strict";
extensions.add(CanvasTextSystem);
extensions.add(CanvasTextPipe);
//# sourceMappingURL=init.mjs.map
